/* ============================================================
   KROQ — Guides

   Une seule mission : rendre les tableaux d'un Guide atteignables
   au clavier.

   Le défilement horizontal est déjà assuré par la CSS, sans
   JavaScript. Mais une boîte qui défile n'est pas focusable par
   défaut : un visiteur au clavier ne peut pas atteindre les
   colonnes de droite. Ce script enveloppe donc chaque tableau
   dans une région focusable — et seulement quand le tableau
   déborde réellement.

   Aucun framework, aucune dépendance, aucun écouteur permanent
   en dehors du redimensionnement.
   ============================================================ */
(function () {
  'use strict';

  var LABEL = 'Tableau, défilement horizontal';

  // Référence conservée hors de `init` : un ResizeObserver sans
  // référence forte peut être ramassé par le GC, et ses observations
  // cessent alors en silence.
  var observer = null;

  function wrap(table) {
    if (table.parentElement && table.parentElement.classList.contains('kg-table-scroll')) {
      return table.parentElement;
    }
    var box = document.createElement('div');
    box.className = 'kg-table-scroll';
    box.setAttribute('role', 'region');
    box.setAttribute('aria-label', table.getAttribute('data-label') || LABEL);
    table.parentNode.insertBefore(box, table);
    box.appendChild(table);
    return box;
  }

  function sync(box) {
    // Focusable seulement s'il y a vraiment quelque chose à atteindre :
    // un tabstop qui ne mène nulle part est une gêne, pas une aide.
    var overflows = box.scrollWidth > box.clientWidth + 1;
    if (overflows) {
      box.setAttribute('tabindex', '0');
    } else {
      box.removeAttribute('tabindex');
    }
  }

  function init() {
    var content = document.querySelector('.kroq-article-content');
    if (!content) return;

    var boxes = [];
    var tables = content.querySelectorAll('table');
    for (var i = 0; i < tables.length; i++) {
      boxes.push(wrap(tables[i]));
    }
    if (!boxes.length) return;

    var apply = function () {
      for (var i = 0; i < boxes.length; i++) sync(boxes[i]);
    };
    apply();

    // ResizeObserver et non l'évènement `resize` de la fenêtre : la
    // largeur d'un tableau change aussi quand la police finit de
    // charger ou qu'un conteneur se réajuste, sans que la fenêtre
    // bouge. Mesuré en préversion, un `tabindex` posé en 375px
    // survivait au passage en grand écran, où il ne menait plus nulle
    // part.
    if (typeof ResizeObserver === 'function') {
      observer = new ResizeObserver(apply);
      for (var j = 0; j < boxes.length; j++) observer.observe(boxes[j]);
    } else {
      var timer;
      window.addEventListener('resize', function () {
        clearTimeout(timer);
        timer = setTimeout(apply, 150);
      });
    }

    // Filet de sécurité : les callbacks du ResizeObserver passent par
    // le rythme d'affichage. `load` n'en dépend pas, et arrive après
    // les polices et les images — deux choses qui changent la largeur
    // d'un tableau.
    window.addEventListener('load', apply, { once: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
